"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICompensationAction = exports.IDisputeAction = exports.ITradeState = exports.Version = void 0;
const index_1 = require("../../index");
var Version;
(function (Version) {
    Version["Old"] = "Old";
    Version["Current"] = "Current";
})(Version = exports.Version || (exports.Version = {}));
exports.ITradeState = index_1.TradeState;
exports.IDisputeAction = index_1.DisputeAction;
exports.ICompensationAction = index_1.CompensationAction;
